// src/features/delegations/hooks/useDelegations.js
import { useState, useCallback } from 'react';
import { delegationsAPI } from '../services/delegations';
import { useApi } from '../../../hooks/api/useApi';

export function useDelegations() {
  const [currentDelegation, setCurrentDelegation] = useState(null);
  const [revisions, setRevisions] = useState([]);
  const { loading, error, execute, clearError } = useApi();

  const fetchDelegation = useCallback(async (delegationId) => {
    const result = await execute(() => delegationsAPI.getDelegation(delegationId));
    if (result.success) setCurrentDelegation(result.data?.data ?? null);
    return result;
  }, [execute]);

  const createDelegation = useCallback(async (data) => {
    return execute(() => delegationsAPI.createDelegation(data));
  }, [execute]);

  const createRevision = useCallback(async (delegationId, data) => {
    return execute(() => delegationsAPI.createRevision(delegationId, data));
  }, [execute]);

  const signRevision = useCallback(async (delegationId, revisionId) => {
    return execute(() => delegationsAPI.signRevision(delegationId, revisionId));
  }, [execute]);

  const archiveDelegation = useCallback(async (delegationId) => {
    return execute(() => delegationsAPI.archiveDelegation(delegationId));
  }, [execute]);

  const fetchRevisionHistory = useCallback(async (delegationId) => {
    const result = await execute(() => delegationsAPI.getRevisionHistory(delegationId));
    if (result.success) setRevisions(result.data?.data ?? []);
    return result;
  }, [execute]);

  const deleteDelegation = useCallback(async (delegationId) => {
    const result = await execute(() => delegationsAPI.deleteDelegation(delegationId));
    if (result.success) setCurrentDelegation(null);
    return result;
  }, [execute]);

  return {
    currentDelegation,
    revisions,
    loading,
    error,
    clearError,
    fetchDelegation,
    fetchRevisionHistory,
    createDelegation,
    createRevision,
    signRevision,
    archiveDelegation,
    deleteDelegation,
  };
}
